import { connect } from "react-redux";
import COSInvoiceListPage from "./COSInvoiceListPage";
import {
  getCreatedCosInvoicesRequest,
  RemoveReviewCaseNoteList,
  getCosInvoiceModeRequest,
  updateCosInvoiceModeRequest,
  changeNDISClaimCaseNoteInvoiceStatusRequest,
} from "store/actions/cos.actions";
import {
  createdCosInvoicesLoader,
  getCOSInvoiceLoaderSelector,
  getCreatedCosInvoiceSelector,
  cosInvoiceModeSelector,
  changeNDISCaseNotesInvoiceStatusLoadingSelector,
} from "store/selector/cos.selector";

const mapDispatchToProps = {
  emptyTableData: RemoveReviewCaseNoteList,
  getInvoicesList: getCreatedCosInvoicesRequest,
  getCosInvoiceMode: getCosInvoiceModeRequest,
  updateCosInvoiceMode: updateCosInvoiceModeRequest,
  changeInvoiceStatus: changeNDISClaimCaseNoteInvoiceStatusRequest,
};

const mapStateToProps = (state) => {
  const cosInvoiceLoading = getCOSInvoiceLoaderSelector(state);
  const createdCosInvoiceLoading = createdCosInvoicesLoader(state);
  const createdCosInvoice = getCreatedCosInvoiceSelector(state);
  const cosInvoiceMode = cosInvoiceModeSelector(state);
  const changeInvoiceStatusLoading = changeNDISCaseNotesInvoiceStatusLoadingSelector(state);

  return {
    cosInvoiceLoading,
    createdCosInvoiceLoading,
    createdCosInvoice,
    cosInvoiceMode,
    changeInvoiceStatusLoading,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(COSInvoiceListPage);
